// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"475":"a7c3a7ea","978":"0c39f29a"}[chunkId] + ".chunk.css";
};